import Vue from 'vue'
import VueRouter from 'vue-router'
import { logoutSystem } from '@/api'
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: "Index",
            component: () => import('@/views/index'),
        },
        {
            path: '/en',
            name: "English",
            component: () => import('@/views/english/index'),
        },
        {
            path: '/report/:language/:id',
            name: "Report",
            component: () => import('@/views/report/index'),
        },
        {
            path: '/single/:language/:id',
            name: "Single",
            component: () => import('@/views/single/index'),
        },
        {
            path: '/special/:language/:id',
            name: "Special",
            component: () => import('@/views/special/index'),
        },
        {
            path: '/mailPush/:language',
            name: "MailPush",
            component: () => import('@/views/mailPush/index'),
        },
        {
            path: '/equity/:language',
            name: "Equity",
            component: () => import('@/views/equity/index'),
        },
        {
            path: '/activity/:language/:id',
            name: "Activity",
            component: () => import('@/views/activity/index'),
        },
        {
            path: '/institution-application/:language',
            name: "InstitutionApplication",
            component: () => import('@/views/institutionApplication/index'),
        },
        {
            path: "*",
            meta: {
                title: '404'
            },
            component: () => import('@/views/errors/error404.vue'),
        },
        {
            path: "/stop",
            meta: {
                title: '暂停服务'
            },
            component: () => import('@/views/errors/errorStop.vue'),
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    if (to.query.login === '1') {
        const token = localStorage.getItem('cf40-token');
        localStorage.removeItem('cf40-token');
        if (token) {
            try { await logoutSystem(to.path === '/en', token); } catch (error) { /* 本地会话已经清除。 */ }
        }
    }
    next();
});

export default router;
